export const routes = {
    toHome: '/home',
    waiting:'/waiting',
    toLogin:'/login',
    toClient: '/client/:clientId',
    goToClient: (clientId: number) => `/client/${clientId}`,
    toAllLaunchesStatistic: '/statistic'
}